import { useMutation } from "@tanstack/react-query";

import { AuthorizationCodeBody, api } from "@/lib/api";

export const useExchangeTokenMutation = () => {
  return useMutation({
    mutationFn: ({ authorization_code, callback_url }: AuthorizationCodeBody) =>
      api.authorization.loginWithAuthorizationCode({
        authorization_code,
        callback_url,
      }),
  });
};
